<div class="dialog-wrapper-container">
    <ng-container #dialogContainer></ng-container>
    <button (click)="save()">Save</button>
</div>
